import { signal } from '@preact/signals-react';

export type PersonaChatState = 'idle' | 'starting' | 'listening' | 'transcribing' | 'speaking';

export const personaChatUiOpen = signal<boolean>(false);
export const personaChatSessionId = signal<string>('');
export const personaChatState = signal<PersonaChatState>('idle');
export const personaChatIsRecording = signal<boolean>(false);
export const personaChatIsLoading = signal<boolean>(false);
export const personaChatIsResponding = signal<boolean>(false);
export const personaChatError = signal<string | null>(null);
export const personaChatLastUserText = signal<string | null>(null);
export const personaChatLastAiText = signal<string | null>(null);
export const personaChatLastUserAt = signal<number | null>(null);
export const personaChatLastAiAt = signal<number | null>(null);

export const resetPersonaChatSignals = () => {
  personaChatUiOpen.value = false;
  personaChatSessionId.value = '';
  personaChatState.value = 'idle';
  personaChatIsRecording.value = false;
  personaChatIsLoading.value = false;
  personaChatIsResponding.value = false;
  personaChatError.value = null;
  personaChatLastUserText.value = null;
  personaChatLastAiText.value = null;
  personaChatLastUserAt.value = null;
  personaChatLastAiAt.value = null;
};
